var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navBar',{attrs:{"title":"Ares - Marketing","home":true,"type":"marketing"}})
}
var staticRenderFns = []

export { render, staticRenderFns }